"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.verify = exports.create = exports.parse = void 0;
var crypto_1 = __importDefault(require("crypto"));
var SPEC_ALGORITHMS = ['sha256', 'sha384', 'sha512'];
// TODO: this should really be a hardcoded list of algorithms we support,
// rather than [a-z0-9].
var BASE64_REGEX = /^[a-z0-9+/]+(?:=?=?)$/i;
// eslint-disable-next-line unicorn/no-unsafe-regex
var STRICT_SRI_REGEX = /^([a-z0-9]+)-([A-Za-z0-9+/=]{44,88})(\?[\x21-\x7E]*)?$/;
var VCHAR_REGEX = /^[\x21-\x7E]+$/;
var getOptString = function (options) { return (!options || !options.length ? '' : "?".concat(options.join('?'))); };
var Hash = /** @class */ (function () {
    function Hash(hash) {
        this.source = hash.trim();
        // set default values so that we make V8 happy to
        // always see a familiar object template.
        this.digest = '';
        this.algorithm = '';
        this.options = [];
        // 3.1. Integrity metadata (called "Hash" by ssri)
        // https://w3c.github.io/webappsec-subresource-integrity/#integrity-metadata-description
        var match = this.source.match(STRICT_SRI_REGEX);
        if (!match) {
            return;
        }
        else if (!SPEC_ALGORITHMS.some(function (a) { return a === match[1]; })) {
            return;
        }
        this.algorithm = match[1];
        this.digest = match[2];
        var rawOpts = match[3];
        if (rawOpts) {
            this.options = rawOpts.slice(1).split('?');
        }
    }
    Hash.prototype.toJSON = function () {
        return this.toString();
    };
    Hash.prototype.toString = function () {
        var _this = this;
        if (!(
        // The spec has very restricted productions for algorithms.
        // https://www.w3.org/TR/CSP2/#source-list-syntax
        (SPEC_ALGORITHMS.some(function (x) { return x === _this.algorithm; }) &&
            // Usually, if someone insists on using a "different" base64, we
            // leave it as-is, since there's multiple standards, and the
            // specified is not a URL-safe variant.
            // https://www.w3.org/TR/CSP2/#base64_value
            this.digest.match(BASE64_REGEX) &&
            // Option syntax is strictly visual chars.
            // https://w3c.github.io/webappsec-subresource-integrity/#grammardef-option-expression
            // https://tools.ietf.org/html/rfc5234#appendix-B.1
            this.options.every(function (opt) { return opt.match(VCHAR_REGEX); })))) {
            return '';
        }
        var options = this.options && this.options.length ? "?".concat(this.options.join('?')) : '';
        return "".concat(this.algorithm, "-").concat(this.digest).concat(options);
    };
    return Hash;
}());
function parse(sri) {
    if (!sri) {
        return null;
    }
    return new Hash(sri);
}
exports.parse = parse;
function create(data, opts) {
    if (opts === void 0) { opts = {}; }
    // eslint-disable-next-line no-param-reassign
    opts = __assign({ algorithm: 'sha512', options: [] }, opts);
    var algorithm = opts.algorithm;
    var optString = getOptString(opts.options);
    var digest = crypto_1["default"].createHash(algorithm).update(data).digest('base64');
    return new Hash("".concat(algorithm, "-").concat(digest).concat(optString));
}
exports.create = create;
function verify(data, sri) {
    try {
        if (typeof sri === 'object' && sri instanceof Hash) {
            // eslint-disable-next-line no-param-reassign
            sri = sri.toString();
        }
        // eslint-disable-next-line no-param-reassign
        sri = parse(sri);
        if (!sri) {
            return false;
        }
        var algorithm = sri.algorithm;
        var digest = crypto_1["default"].createHash(algorithm).update(data).digest('base64');
        var newSri = parse("".concat(algorithm, "-").concat(digest));
        return sri.toString() === newSri.toString();
    }
    catch (err) {
        // `crypto.createHash()` will throw errors if `algorithm` is invalid which will happen if we're
        // supplied with an invalid or corrupt hash. Since we just want this method to only verify if
        // two given hashes match, we don't want to throw if that happens.
        return false;
    }
}
exports.verify = verify;
